import { formatInr } from "@/lib/format";

/* Wording for the compliance figures. An overdue obligation without a daily fee must never
   read as "₹0 accruing": that sounds like nothing is owed when a penalty may still follow. */

export function accrualText(summary: { accrued_inr: string; accruing_per_day_inr: string }): string {
  if (Number(summary.accruing_per_day_inr) <= 0) {
    return "No daily fee on these; penalties may still apply";
  }
  return `${formatInr(summary.accrued_inr)} accrued, +${formatInr(summary.accruing_per_day_inr)} a day`;
}

/** The next item's name, and how many others are due within 30 days besides it. */
export function dueSoonText(next: { name: string }, dueSoon: number): string {
  const others = dueSoon - 1;
  if (others <= 0) return `${next.name}.`;
  return `${next.name}, and ${others} more due within 30 days.`;
}
